<div id="content">
  <div class="row">
    <div class="flex-item">
      <img mat-card-image class="search-logo" src="https://ppdocumenta.com/assets/imgs/logotipo-color.png" />
    </div>
    <div class="flex-item title">Revista de prensa</div>
    <div class="flex-item subtitle">23 de diciembre 2020</div>
  </div>
</div>
